import React from 'react';

import ReactDOM from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';
import { toast } from 'sonner';

import './index.css';

import * as Sentry from '@sentry/react';

import App from './App';
import { VITE_ENV } from './utils/constants';

if (VITE_ENV !== 'local') {
  Sentry.init({
    dsn: 'https://2d4c08c70450ef130695ecf239a83d9b@o366774.ingest.us.sentry.io/4509628374974464',
    tunnel: 'tu-tu-nail',
    environment: VITE_ENV || 'release',
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      Sentry.replayIntegration()
    ],

    tracePropagationTargets: ['stratumn.com'],

    tracesSampleRate: 1, //  Capture 100% of the transactions
    sampleRate: 1.0,
    profilesSampleRate: 1.0,
    enableTracing: true,

    // Session Replay
    replaysSessionSampleRate: 0.01, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

const rootElement = document.getElementById('root');

if (rootElement) {
  document.addEventListener('keydown', e => {
    if (e.key === 's' && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      toast.info('No need to ctrl-s!', {
        description: 'Everything is saved automagically 🪄'
      });
    }
  });
} else {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
